import React from 'react';
import type { Lead } from '../../types';

export type LeadReativacaoSummaryProps = Pick<
  Lead,
  'isReativacao' | 'reativacaoDetectedAt' | 'reativacaoSource' | 'reativacaoMotivo'
>;

/** Texto readonly exibido em LeadDetails quando o lead foi marcado como reativação por IA. */
export function formatLeadReativacaoSummaryValue(lead: LeadReativacaoSummaryProps): string {
  const data = lead.reativacaoDetectedAt
    ? new Date(lead.reativacaoDetectedAt).toLocaleString('pt-BR')
    : '-';
  const origem = lead.reativacaoSource || 'llm';
  const motivo = lead.reativacaoMotivo ? ` | Motivo: ${lead.reativacaoMotivo}` : '';
  return `Detectado como reativação em ${data} | Origem: ${origem}${motivo}`;
}

/**
 * Bloco de informação de reativação IA (detalhe do lead).
 * Extraído para testes de UI sem montar a página completa.
 */
export const LeadReativacaoSummary: React.FC<LeadReativacaoSummaryProps> = (props) => {
  if (!props.isReativacao) return null;
  return (
    <div className="info-item full-width" data-testid="lead-reativacao-summary">
      <label htmlFor="lead-reativacao-summary-input">Reativação IA</label>
      <input
        id="lead-reativacao-summary-input"
        type="text"
        readOnly
        value={formatLeadReativacaoSummaryValue(props)}
        aria-label="Resumo da reativação detectada pela IA"
      />
    </div>
  );
};
